import React, {createContext, useReducer} from "react";
import {ForceReducer} from "../reducer/ForceReducer";

export const ForceContext = createContext()

const ForceContextProvider = (props) => {
    const forceInitialState = {
        forceCycleConfig : {},
        stationCycleConfig: {},
        selectedCycleName: "",
        selectedForceInductStatus: "",
        alert: {id: "", default: "", values: {}, type: "error"}
    }
    const [forceViewModel, forceDispatch] = useReducer(ForceReducer, forceInitialState)
    return (
        <ForceContext.Provider value = {{forceViewModel, forceDispatch}}>
            {props.children}
        </ForceContext.Provider>
    )
}

export default ForceContextProvider


// WEBPACK FOOTER //
// ./src/components/inductmanagementv2/context/ForceContext.js